/** @module csi/action/SubmitController */
define([
	"underscore",
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/html",
	"csi/locale",
	"csi/xml"
], function (_, declare, Controller, PostRequest, def, html, locale, xml) {

	return declare(Controller, {
		bShowWait: true,

		/** @property {string} buttonResource - resource id to use for submit button */
		buttonResource: "Upload",

		/** @property {string} downloadAs - download the response as a given file */
		downloadAs: null,

		/**
		 * @override
		 * Default button should be "Upload"
		 */
		addProxyActions: function (defView, defActions) {
			defActions.addAction(this.getProxyAction(null, false, {
				m_bSubmit: true,
				m_name: locale.resource(this.buttonResource)
			}));

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Validate form before continuing
		 */
		onPreActionDeferreds: function (dfds) {
			dfds.push(this.validate());
		},

		/**
		 * Extension point to configure request
		 * @param {PostRequest} request
		 */
		onUploadRequest: function (request) { },

		/**
		 * @override
		 * Create PostRequest to submit file along with any parameters from form fields
		 */
		process: function () {
			var actionRequest = this.m_action.m_request;
			var request = new PostRequest(actionRequest.m_module, actionRequest.m_operation);
			var view = this.popupView || this.widget;
			var fields = view.defView.m_fields;

			request.addParameter(xml.PROP_URL, this.m_urlNode);

			if (xml.isValidURL(this.m_urlParent)) {
				request.addParameter(xml.PROP_URL_PARENT, this.m_urlParent);
				request.addParameter(xml.PROP_ATTR_PARENT, this.m_idAttrParent);
			}

			_.each(actionRequest.m_parameters, function (p) {
				request.addParameter(p.m_id, p.m_value);
			});

			_.each(fields, function (f) {
				if (f.m_typeControl == def.FIELD_FILE) {
					// f.getValue() only returns file name rather than File object
					request.addFiles(html.getInputFileArray(f.m_control), f.idParameter || f.getControlName());
				} else if (f.idParameter) {
					request.addParameter(f.idParameter, f.getValue());
				}
			});

			this.onUploadRequest(request);

			const ioArgs = { handleAs: this.downloadAs ? "blob" : "json" };
			let post = request.post(ioArgs);
			if (this.downloadAs) {
				post = post.then((response) => {
					html.download(this.downloadAs, response.data);
				});
			}
			this.waitForPublish(post, true);
		}
	});
});
